import React from 'react';
import styles from './index.module.scss';
import search from '../../assets/images/search.svg';
import close from '../../assets/images/close.svg';

const SearchAnimated = ({
  placeholder,
  value,
  onChange,
  isSearchFocused,
  setIsSearchFocused,
}) => {
  return (
    <div
      className={`${styles.searchWrapper} ${isSearchFocused ? styles.focused : ''}`}
      onClick={() => setIsSearchFocused(true)}
    >
      <img src={search} alt="search" className={styles.searchImg} />
      <input
        type="text"
        className={styles.searchInput}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value?.length > 0 && (
        <img
          src={close}
          alt="close"
          className={styles.closeImg}
          onClick={() => onChange('')}
        />
      )}
    </div>
  );
};
export default SearchAnimated;
